const initFormImage = (imageInput) => {

    const imagePreview = document.querySelector('.js-image-preview');
    let currentObjectUrl;

    if(imageInput && imagePreview) {
    
        const handleImageUpdate = () => {
            const file = imageInput.files[0];
            if (!file) return;

            // Clean up the old object URL if it exists
            if (currentObjectUrl) {
                URL.revokeObjectURL(currentObjectUrl);
            }

            // Create a new object URL
            currentObjectUrl = URL.createObjectURL(file);

            // Use it for preview
            imagePreview.src = currentObjectUrl;
            imagePreview.parentNode.classList.toggle('hidden', !currentObjectUrl);
        }

        imageInput.addEventListener('change', () => {
            handleImageUpdate();
        })
    }

}

export default initFormImage;
